import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";

const EditProfile = () => {
  const [profiles, setProfiles] = useState([]);
  // Retrieve the initial set of tweets and put them into State
  const url = 'https://enigmatic-fortress-23182.herokuapp.com/api/profile';
  useEffect(() =>
      fetch(url)
      .then(response => response.json())
      .then(profiles => setProfiles(profiles)), []);
  const history = useHistory()
  const dispatch = useDispatch();

  const updateProfileClickHandler = (profile) => {
    let url = `https://enigmatic-fortress-23182.herokuapp.com/api/profile/${profile.handle}`;
    fetch(url,  {
      method: 'PUT',
      body: JSON.stringify(profile),
      headers: {
        "Content-Type": "application/json"
      }
    }).then(response => dispatch({
      type: 'update-profile',
      profile
    }));
  }

  return(
      <div>
        <h4>
          <button className={"btn fas fa-times"}
                  onClick={() => {history.goBack()}}></button>
          Edit profile</h4>
        <ul className="list-group">
        {
        profiles.map((profile)=>
            <li>
            <button className = "btn btn-secondary rounded-pill float-end me-5 mt-3" onClick={(event) => {updateProfileClickHandler({...profile})}}>
              Save
            </button>
            <h6 className={"text-secondary"}>{profile.save} Tweets</h6>
            <img style={{display: "flex"}}
                 src={profile.bannerPicture}
                 alt={"banner"}
                 width="100%"
                 height="200px"/>
            <img className="rounded-circle wd-avatar-image"
                 style={{width: '144px', float: "top", marginTop: "-8%", position: "relative", zIndex: 1}}
                 alt={"avatar"}
                 src={profile.profilePicture}/>

            <form className="form-floating">
              <input type="name" className="form-control bg-transparent text-white" id="firstName"
                     onChange={e => profile.firstName = e.target.value}
                     placeholder="first name" defaultValue={profile.firstName}/>
              <label>First Name</label>
            </form>
            <form className="form-floating">
              <input type="name" className="form-control bg-transparent text-white" id="lastName"
                     onChange={e => profile.lastName = e.target.value}
                     placeholder="last name" defaultValue={profile.lastName}/>
              <label>Last Name</label>
            </form>
            <form className="form-floating">
              <input type="bio" className="form-control bg-transparent text-white" id="bio"
                     onChange={e => profile.bio = e.target.value}
                     placeholder="who am I" defaultValue={profile.bio}/>
              <label>Bio</label>
            </form>
            <form className="form-floating">
              <input type="location" className="form-control bg-transparent text-white" id="location"
                     onChange={e => profile.location = e.target.value}
                     placeholder="my location" defaultValue={profile.location}/>
              <label>Location</label>
            </form>
            <form className="form-floating">
              <input type="website" className="form-control bg-transparent text-white" id="website"
                     onChange={e => profile.website = e.target.value}
                     placeholder="my site" defaultValue={profile.website}/>
              <label>Website</label>
            </form>

            <h6 className={"ms-3 text-secondary"}>Birth date<a href={'#top'} className="btn text-primary">Edit</a></h6>
            <a href={'#top'} className={"text-white text-decoration-none ms-3"}>{profile.dateOfBirth}</a>
             </li>
          )
        }
        </ul>
          </div>
  );

};
export default EditProfile;
